import React from 'react';
import PropTypes from 'prop-types';

import { Rectangle } from 'recharts';

const BAR_COLOR_PURPLE = '#6929c4';
const BAR_COLOR_RED = '#e32707';

const CustomBar = (props) => {
  const { normalizedSla, id } = props;
  const fill = id > normalizedSla ? BAR_COLOR_RED : BAR_COLOR_PURPLE;
  return <Rectangle {...props} fill={fill} />;
};

CustomBar.propTypes = {
  normalizedSla: PropTypes.number.isRequired,
  id: PropTypes.number,
};

export default CustomBar;
